import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { SignInService } from "../services/sign-in.service";

@Injectable({
  providedIn: 'root'
})

export class SignInDetailsResolver  {
  constructor(private signInService: SignInService) { }

  resolve(): Observable<any> {
    return this.signInService.selectSignInStore().pipe(take(1));
  }
}